import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/features/shell/Shell.tsx");
